module.exports = __webpack_public_path__ + "img/level1_running.ee379048.png";